/* eslint-disable */
import { useToken } from "./useToken";

function Logout() {
  const { logout } = useToken();
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await logout();
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <button
        className="text-white font-medium hover:text-gray-400 transition duration-300"
        type="submit"
      >
        Logout
      </button>
    </form>
  );
}

export default Logout;


// const handleSubmit = async (event) => {
//   event.preventDefault();
//   const confirmed = window.confirm("Are you sure you want to log out?");
//   if (confirmed) {
//     try {
//       await logout();
//     } catch (e) {
//       console.error(e);
//     }
//   }
// };




// import React from "react";

// const LogoutButton = () => {
//   const handleLogout = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_HOST}/token`, {
//         method: "delete",
//         credentials: "include", // Include cookies in the request
//       });

//       if (response.ok) {
//         // Redirect or perform any other action after successful logout
//         window.location.replace("/login");
//       } else {
//         // Handle error, display a message, etc.
//         console.error("Logout failed");
//       }
//     } catch (error) {
//       console.error("Error during logout", error);
//     }
//   };

//   return <button onClick={handleLogout}>Logout</button>;
// };

// export default LogoutButton;
